"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 401.8 400.8",
    width: "100%",
    height: "100%",
    children: (0, jsx_runtime_1.jsx)("path", {
      fill: "currentColor",
      d: "M353.5,113.5c-13.2-48.5-36.1-84-36.3-84.3c-0.3-0.4-0.9-0.8-1.4-0.8s-1.1,0.3-1.4,0.8\n\tc-0.4,0.6-40.1,64.1-96.8,78.6c-16.2,4.2-31,7.5-44.1,10.5C116.8,131,85.5,138,72.1,184.4c-9.1,31.5,0.8,67.1,10.6,91.6\n\tc6.2,15.2,13.1,28.1,17.8,36.2c-20.4,6.9-47,14.7-78.1,21.5c-0.6,0.1-1.2,0.6-1.3,1.4c-0.1,0.6,0.2,1.3,0.9,1.6l27.1,13.5\n\tc19.7-7.6,64.6-26.4,111.3-57.6c36.4-24.4,66.8-51.5,90.4-80.4c29.4-36.2,48-75.5,55.4-116.8l1.1,0.1c0,0.5-1.3,52.9-30.6,114.3\n\tc-17.2,36-40.5,68.1-69.3,95.3c-12.9,12.1-26.9,23.4-42,33.5c8.5,1.5,17.7,2.6,27.1,3.2c5.1,0.3,10.2,0.5,15.1,0.5\n\tc21.5,0,41.3-3.1,58.9-9.5c27.2-9.7,49.4-27,66.1-51.4c17.4-25.4,27.4-54.6,29.6-86.6C364.3,169.4,361.2,141.9,353.5,113.5z"
    })
  });
};

exports.default = Icon;